import { render, staticRenderFns } from "./Event.vue?vue&type=template&id=4bda4c70&scoped=true"
import script from "./Event.vue?vue&type=script&lang=js"
export * from "./Event.vue?vue&type=script&lang=js"
import style0 from "vue-multiselect/dist/vue-multiselect.min.css?vue&type=style&index=0&prod&lang=css&external"
import style1 from "./Event.vue?vue&type=style&index=1&id=4bda4c70&prod&scoped=true&lang=css"
import style2 from "./Event.vue?vue&type=style&index=2&id=4bda4c70&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bda4c70",
  null
  
)

export default component.exports